/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'linkin': {
    width: 30.71,
    height: 30.71,
    viewBox: '0 0 30.71 30.71',
    data: '<path fill="black" d="M9.91 4.41a1.81 1.81 0 1 0 1.81 1.81 1.81 1.81 0 0 0-1.81-1.81zM8.1 9.84h3.62V22.5H8.1zM20.31 9.84c-1.28 0-2.42 1.22-3.17 2.24V9.84h-3.61V22.5h3.61v-7.23a1.81 1.81 0 0 1 3.62 0v7.23h3.62v-8.14a4.31 4.31 0 0 0-4.07-4.52z"/><path fill="white" d="M15.35 0a15.36 15.36 0 1 0 15.36 15.35A15.35 15.35 0 0 0 15.35 0zm-3.63 22.5H8.1V9.84h3.62zM9.91 8a1.81 1.81 0 1 1 1.81-1.81A1.81 1.81 0 0 1 9.91 8zm14.47 14.5h-3.62v-7.23a1.81 1.81 0 0 0-3.62 0v7.23h-3.61V9.84h3.61v2.24c.75-1 1.89-2.24 3.17-2.24a4.31 4.31 0 0 1 4.07 4.52z"/>'
  }
})
